var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DataInquiryServiceApi from '~/api/submission-engine/dataInquiryService';
import { keysToCamel } from '~/utils/toCamelCase';
const getDocumentData = (doc) => __awaiter(void 0, void 0, void 0, function* () {
    const response = keysToCamel(yield DataInquiryServiceApi.getDocumentData(doc.txId), false);
    if (!response || response.errors.length) {
        throw Error(`Error fetching data for ${doc.txId}`);
    }
    if (!response.data || !Array.isArray(response.data) || response.data.length !== 1) {
        console.warn(`Transaction ${doc.txId} did not return data array. Skipping...`);
        return { clauses: {}, decPageFields: {} };
    }
    const data = keysToCamel(response.data[0], false);
    if (!Object.keys(data).includes('clauses')) {
        console.warn(`Transaction ${doc.txId} data did not include clauses. Skipping...`);
        data.clauses = {};
    }
    for (const [key, value] of Object.entries(data.clauses)) {
        data.clauses[key] = keysToCamel(value, false);
        data.clauses[key].sources = data.clauses[key].sources.map(s => {
            const source = keysToCamel(s, false);
            source.coordinates = source.coordinates
                ? keysToCamel(source.coordinates)
                : { x1: 0, x2: 0, y1: 0, y2: 0 };
            if (source.checkList) {
                for (const [checkKey, checkValue] of Object.entries(source.checkList)) {
                    source.checkList[checkKey] = keysToCamel(checkValue);
                }
            }
            else {
                source.checkList = {};
            }
            return source;
        });
        if (data.clauses[key].checklistItems) {
            for (const [checkKey, checkValue] of Object.entries(data.clauses[key].checklistItems)) {
                data.clauses[key].checklistItems[checkKey] = keysToCamel(checkValue);
            }
        }
        else {
            data.clauses[key].checklistItems = {};
        }
    }
    if (!Object.keys(data).includes('decPageFields')) {
        console.warn(`Transaction ${doc.txId} data did not include decPageFields. Skipping...`);
        data.decPageFields = {};
    }
    for (const [key, value] of Object.entries(data.decPageFields)) {
        if (Object.keys(value).includes('value')) {
            data.decPageFields[key] = [keysToCamel(value, false)];
        }
        else {
            const transformed = [];
            for (const [decKey, decValue] of Object.entries(data.decPageFields[key])) {
                transformed.push(keysToCamel({ value: decValue, subkey: decKey }, false));
            }
            data.decPageFields[key] = transformed;
        }
    }
    return data;
});
export default getDocumentData;
